import Section from "@/components/Section";
import { ROUTES } from "@/utils/navigation";
import { Box, Button, CardMedia, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import line_url from "@/assets/icons/solutions/dividing-line.svg";
import AdvantageItem from "./components/AdvantageItem";
import IndividualCarIcon from "@/assets/icons/solutions/individual-car.svg?react";
import FleetCarIcon from "@/assets/icons/solutions/fleet-car.svg?react";
import { forFleetsList, forIndividualsList } from "./mockData";

const AdvantagesSection = () => {
  const theme = useTheme();
  return (
    <Section pt={{ xs: 3.5, md: 8.5 }} pb={{ xs: 2, md: 8.5 }}>
      <Box
        sx={{
          backgroundColor: { xs: "none", md: theme.palette.background.default },
          padding: { xs: "0px", md: "46px 50px 69px" },
          borderRadius: "20px"
        }}
      >
        <Typography 
          variant="h2"
          sx={{
            marginBottom: { xs: "24px", md: "60px" },
          }}
        >
          Versatility for Every Need
        </Typography>
        <Box
          sx={{
            backgroundColor: { xs: theme.palette.background.default, md: "none" },
            borderRadius: "20px",
            padding: { xs: "16px", md: "0px" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: { xs: "center", md: "space-between" },
              marginBottom: { xs: "32px", md: "70px"},
            }}
          >
            <AdvantageItem 
              icon={IndividualCarIcon}
              title="For individuals"
              list={forIndividualsList}
            />
            <CardMedia
              component="img"
              image={line_url}
              alt=""
              sx={{
                transform: { xs: "rotate(0deg)", md: "rotate(90deg)" },
                maxWidth: { xs:"311px", md: "192px" },
                height: "2px",
                alignSelf: { xs: "start", md: "center" }
              }}
            />
            <AdvantageItem 
              icon={FleetCarIcon}
              title="For fleets"
              list={forFleetsList}
            />
          </Box>
          <Button 
            component={Link} 
            to={ROUTES.features} 
            color="primary" 
            variant="contained" 
            disableElevation 
            sx={{
              maxWidth: "311px",
              width: "100%"
            }}
          >
            Explore features
          </Button>
        </Box>
      </Box>
    </Section>
  );
};

export default AdvantagesSection;